// JavaScript Document
//components/signs/Signs.js
import React from 'react';
import TableRow from '@material-ui/core/TableRow';
import { Link, useNavigate } from 'react-router-dom';
import fields from './view/Fields';
import ListView from '../view/View';
import Fab from '@material-ui/core/Fab';
import AddIcon from '@material-ui/icons/Add';
import { makeStyles } from '@material-ui/core/styles';
import Tooltip from '@material-ui/core/Tooltip';

const useStyles = makeStyles((theme) => ({
	fab: {
		position: 'absolute',
		bottom: theme.spacing(2),
		right: theme.spacing(2),
	},
}))

//Definition of the row template
const Row = (props) => {
	const {children, row} = props;
	const navigate = useNavigate();
	const clicked = (e) => {
		navigate('/sign/'+row.id);
	}
	return (
		<TableRow 
			hover 
			role="checkbox" 
			onClick={clicked}
		>
			{children}
		</TableRow>
	)
}


export default function Signs(props) {
	//Inherited props
  	const {handleSend, user, organization} = props;
	//control loading from server
  	const [loaded, setLoaded] = React.useState(false);
	//list of signs unfiltered
  	const [signsList, setSignsList] = React.useState([]);
	//styles (for FAB - Floating Action Button)
	const classes = useStyles();
	//default view
  	const defaultView = {
		id : 0,
		lv_name : 'All Signs',
		lv_table : 'signs',
		lv_fields : [
			{
        		name : 'location'
    		}, {
        		name : 'sign_type'
    		}, {
        		name : 'description'
    		}, {
        		name : 'config_name'
    		}, {
        		name : 'ip'
    		}
		],
		lv_filter : {
			type : 'AND',
			custom : '',
			conditions : []
		},
		lv_sort : [],
		sharing : 'private'
  	};
	
	//on state change
  	React.useEffect(() => {
		//if signs have not been loaded from UI yet
		if(!loaded){
			getSignsList();
		}
	});
	//get signs from server
  	const getSignsList = () =>{
		setLoaded(true);
	  	handleSend({
		  	vso: 'signslist'
	  	}, (data) => {
		  	setSignsList(data.signs);
	  	});
  	}

	//compile result in ListView
	return (
		<React.Fragment>
			<ListView 
				label="Signs"
				user={user} 
				organization={organization} 
				handleSend={handleSend} 
				fields={fields} 
				items={signsList} 
				defaultView={defaultView} 
				RowTemplate={Row} 
				selectRows={true} />
			<Tooltip title="Add Sign" aria-label="add sign" >
			<Fab component={Link} to="/addsign" className={classes.fab} color="primary" aria-label="Add sign">
				<AddIcon />
			</Fab>
			</Tooltip>
		</React.Fragment>
	);
}
